<template>
  <v-card class="card" color="surface" elevation="12">
    <v-row class="justify-begin align-center">
      <v-col cols="auto" v-if="favCardFavorit.seat.id">
        <FavoriteButton 
          :favBtnIsFavorite="true"
          :favBtnSeatID="favCardFavorit.seat.id"
          :favBtnFavoriteID="favCardFavorit.id"
          @updateFavorite="this.$emit('updateFavorite')"/>
      </v-col>
    </v-row>
    <v-row class="justify-center align-center mt-n16">
      <v-col cols="auto">
        <v-card-title class="txtTitle">{{ favCardFavorit.seat.description }}</v-card-title>
      </v-col>
    </v-row>
    <v-row class="justify-center align-center mt-n6">
      <v-col cols="auto">
        <v-card-subtitle class="txtFullName text-subtitle-1">{{ favCardFavorit.seat.room + ', Platz ' + favCardFavorit.seat.name  }}</v-card-subtitle>
      </v-col>
    </v-row>
    <v-row dense class="justify-center align-center ma-2">
      <v-col cols="auto">
          <v-btn  @click="showDialogSeatPlan" variant="elevated" color="onBackground" prependIcon="mdi-map-outline">Sitzplan</v-btn>
      </v-col>
      <v-col cols="auto">
          <v-btn  @click="getOccupancy" variant="elevated" color="grey" prependIcon="mdi-calendar">Belegung</v-btn>
      </v-col>
      <v-col cols="auto">
        <v-btn  @click="showDialogBooking" variant="elevated" color="primary" prependIcon="mdi-check-circle">buchen</v-btn>
      </v-col>
    </v-row>
  </v-card>

  <SeatPlanDialog
    ref="seatPlanDialogRef"
    :dialogSeatPlanImagePath="favPremise ? favPremise.image : ''"
    :dialogSeatPlanSeat="favCardFavorit.seat"/>

  <BookingDialog 
    ref="bookingDialogRef"
    :bookingDialogStartDate="favCardStartDate"
    :bookingDialogEndDate="favCardEndDate"
    :bookingDialogUsers="favCardUsers"
    :bookingDialogSeat="favCardSeat"
    @updateSeatStatus="this.$emit('updateStatus')"
    @updateFavorite="this.$emit('updateFavorite')"
  />

  </template>

  <script>

  import FavoriteButton from '../consumables/FavoriteButton.vue';
  import SeatPlanDialog from './SeatPlanDialog.vue';
  import BookingDialog from './BookingDialog.vue';
  
  export default {
    name: "FavoriteCard",
    components: {
      FavoriteButton,
      SeatPlanDialog,
      BookingDialog,
    },

    data() {
      return {
        favCardSeat: null,
        favCardPremise: null
      }
    },

    emits: ['updateStatus', 'updateFavorite', 'openOccupancy'],

    props: {
      favCardFavorit: {type: Object, default: null},
      favCardUsers: {type: Object, default: null},
      favCardPremises: {type: Object, default: null},
      favCardStartDate: {type: String, required: true},
      favCardEndDate: {type: String, required: true}
    },

    watch: {
      favCardFavorit: {
        handler(newVal) {
          this.favCardSeat = {
            ...newVal.seat,
            isFavorite: true,
            favoriteID: newVal.id
          }
        },
        immediate: true,
        deep: true
      }
    },

    computed: {
      favPremise() {
        if (!this.favCardPremises || !this.favCardFavorit) return null
        return this.favCardPremises.find(p => p.shortPrem === this.favCardFavorit.seat.locationPath) || null
      }
    },

    methods: {

      showDialogSeatPlan(){
        console.log('Favorit', this.favCardFavorit)
        console.log('Premises', this.favCardPremises)
        this.$refs.seatPlanDialogRef.openDialogSeatPlan();
      },

      getOccupancy(){
        this.$emit('openOccupancy', this.favCardFavorit.seat)
      },

      showDialogBooking(){
        console.log('Hallo Favoritensitz', this.favCardFavorit)
        this.$refs.bookingDialogRef.openDialogBooking()
      },
    }
  };

  </script>
  
  <style scoped>
.card {
  max-width: fit-content;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  margin-bottom: 0.1rem;
}
.txtTitle {
  color: rgb(var(--v-theme-on-surface));
}
.txtFullName {
  font-style: italic;
  color: rgb(var(--v-theme-on-surface));
}
.v-btn {
  font-size: small !important;
}
  </style>